var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('main',[_c('home-banner-slider'),_c('discount-list'),_c('app-popular-categories'),_c('app-stocks'),_c('app-join-club'),_c('app-useful-articles')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }